
<template>
  <div id="page-user-view">
    <div id="user-data">
      <vx-card  class="mb-base"  title="프로젝트 결과">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <!-- <img :src="photoURL" class="rounded w-full" /> -->
            </div>
          </div>
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">팀인원</td>
                <td>{{ memberInfo.length }}명</td>
              </tr>
              <tr>
                <td class="font-semibold">블로그</td>
                <td>{{ total_blog }}Byte</td>
              </tr>
              <tr>
                <td class="font-semibold">완료업무</td>
                <td>{{ total_task }}개</td>
              </tr>
              <tr >
                <td class="font-semibold">최종 산출물</td>
                <td v-if="ActiveDashBoardLevel > 2">
                  <div class="cursor-pointer ml-4" @click="download()">
                    <span style="padding:5px; text-decoration: underline; margin-left:-15px;">다운로드</span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">팀 점수</td>
                <td>
                  <vs-input v-if="ActiveDashBoardLevel > 2" v-model="score" class="mt-3 w-full"/></br>
                  <vs-input v-if="ActiveDashBoardLevel <= 2" :value="score" class="mt-3 w-full" disabled/></br>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">팀 코멘트</td>
                <td>
                  <vs-textarea v-if="ActiveDashBoardLevel > 2" v-model="comment" vs-placeholder="코멘트" class="mt-3 w-full"/>
                  <vs-textarea v-if="ActiveDashBoardLevel <= 2" :value="comment" vs-placeholder="코멘트" class="mt-3 w-full" disabled/>
                </td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons"  v-if="ActiveDashBoardLevel > 2">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" size="small"  @click="saveProjectScore()">저장</vs-button>
            <!-- <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Delete</vs-button> -->
          </div>
        </div>
      </vx-card>
      <vx-card  class="mb-base" :title="member.name" v-for="member in memberInfo" v-bind:key="member.id">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="photoURL(member.photo_url)" class="rounded w-full" />
            </div>
          </div>
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">블로그</td>
                <td>{{ member.blog_size }}Byte</td>
              </tr>
              <tr>
                <td class="font-semibold">완료업무</td>
                <td>{{ member.done_task }}개</td>
              </tr>
              <tr>
                <td class="font-semibold">개인 점수</td>
                <td>
                  <vs-input v-if="ActiveDashBoardLevel > 2" :value="member.score" /></br>
                  <vs-input v-if="ActiveDashBoardLevel <= 2" :value="member.score" disabled/></br>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">개인 코멘트</td>
                <td>
                  <vs-textarea v-if="ActiveDashBoardLevel > 2" :value="member.comment" vs-placeholder="코멘트"/>
                  <vs-textarea v-if="ActiveDashBoardLevel <= 2" :value="member.comment" vs-placeholder="코멘트"  disabled/>
                </td>
              </tr>
            </table>
          </div>
          <div class="vx-col flex-1" id="account-info-col-2">
            <!-- <td class="font-semibold" v-if="!member.prediction">분석 기여도 0%</td> -->
            <vue-apex-charts v-if="!member.prediction" type=radialBar height=300 :options="analyticsData.chartOptions" :series="series"/>
            <vue-apex-charts v-if="member.prediction" type=radialBar height=300 :options="analyticsData.chartOptions" :series="member.prediction"/>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons"  v-if="ActiveDashBoardLevel > 2">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" size="small"  @click="saveMemeberScore(member)">저장</vs-button>
            <!-- <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Delete</vs-button> -->
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// import ECharts from 'vue-echarts/components/ECharts'
// import 'echarts/lib/component/tooltip'
// import 'echarts/lib/component/legend'
// import 'echarts/lib/chart/pie'
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import InsightTestScore from "./cell-renderer/InsightTestScore.vue"
import InsightSubmitScore from "./cell-renderer/InsightSubmitScore.vue"
import VueApexCharts from 'vue-apexcharts'
import apexChatData from './apexChartData.js'
import Vue from 'vue'

export default {
    name: 'InsightTeam',
    components: {
      AgGridVue,
      InsightTestScore,
      InsightSubmitScore,
      VueApexCharts,
    },
    data() {
      return {
        user_data: null,
        user_not_found: false,
        apexChatData: apexChatData,
        themeColors: ['#28C76F', '#EA5455', '#FF9F43', '#7367F0', '#1E1E1E'],
        attendPieChart:null,
        submitPieChart:null,
        columnDefs:[],
        defaultColDef: {
          sortable: true,
          resizable: true,
        },
        gridApi: null,
        userData:[],
        gridOptions: {},
        components: {
          InsightTestScore,
          InsightSubmitScore,
        },
        memberInfo:[],
        projectInfo:null,
        submitVal: {labels:[], series:[]},
        score:'',
        comment:'',
        total_task:0,
        total_blog:0,
        analyticsData:null,
        series: [0],
      }
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      ActiveDashBoardLevel(){
        return this.$store.state.space.ActiveDashBoardLevel
      },
      activeWorkspace() {
        return this.$store.state.space.ActiveSpaceInfo
      },
      paginationPageSize() {
        if(this.gridApi) return this.gridApi.paginationGetPageSize()
        else return 10
      },
      getInsightUser(){
        return this.$store.getters['insight/getInsightUser'](this.$route.params.userId)
      },
      getUserInfo(){
        return this.$store.getters['space/getMemberInfo'](this.$route.params.userId)
      },
      testResults(){
        return this.$store.state.insight.testResults
      },
      currentPage: {
        get() {
          if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
          else return 1
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      },
    },
    mounted () {
      this.gridApi = this.gridOptions.api
    },
    methods: {
      download(){
        // console.log('download')
      },
      saveProjectScore(){
        // console.log('save score')
        var obj = {id:this.projectInfo.id, workspace_id:this.activeWorkspace.id, score:this.score, comment:this.comment}
        this.$store.dispatch("insight/setProjectTeamScore", obj)
      },
      saveMemeberScore(member){
        // console.log(member)
        var obj = {id:member.id, workspace_id:this.activeWorkspace.id, score:member.score, score_comment:member.score_comment}
        this.$store.dispatch("insight/setProjectMemberScore", obj)
      },
      photoURL(val){
        if(val){
          return require("@/assets/images/portrait/small/" + val)
        }else{
          return null
        }
      },
    },
    created() {
      // console.log(this.activeWorkspace.id)
      this.$store.dispatch("insight/getProjectTeamInfo", this.$route.params.projectId).then((resolve)=>{
        // console.log(resolve)
        this.memberInfo = []
        this.projectInfo = resolve.project
        this.total_task = 0
        this.total_blog = 0
        this.score = this.projectInfo.score
        this.comment = this.projectInfo.comment
        for(var i in resolve.memberInfo){
          this.memberInfo.push(resolve.memberInfo[i])
          Vue.set(this.memberInfo[i], 'blog', resolve[resolve.memberInfo[i].user_id+'_blog'])
          Vue.set(this.memberInfo[i], 'blog_size', resolve[resolve.memberInfo[i].user_id+'_blog_size'])
          Vue.set(this.memberInfo[i], 'done_task', resolve[resolve.memberInfo[i].user_id+'_task'])
          this.total_task = this.total_task + this.memberInfo[i].done_task
          this.total_blog = this.total_blog + this.memberInfo[i].blog_size
        }
        for(var j in this.memberInfo){
          var task = (this.memberInfo[j].done_task / this.total_task) * 100
          var blog = (this.memberInfo[j].blog_size / this.total_blog) * 100
          var value = []
          value.push((task + blog)/2)
          Vue.set(this.memberInfo[i], 'prediction', value)
          // console.log(blog)
        }

      })
      this.analyticsData = {
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 158,
              offsetY: -30,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '65%',
              },
              track: {
                background: "rgba(0,0,0,0)",
                strokeWidth: '100%',
              },
              dataLabels: {
                value: {
                  offsetY: 30,
                  color: '#99a2ac',
                  fontSize: '2rem'
                }
              }
            },
          },
          colors: ['#EA5455'],
          fill: {
            type: 'gradient',
            gradient: {
              // enabled: true,
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: ['#7367F0'],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            },
          },
          stroke: {
            dashArray: 10
          },
          labels: ['분석 기여도'],
        }
      }
    }
  }
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }
    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}
// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }
@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
